import {EditorConfig} from '../../../constants/editorConfig'
const InteractionMode = EditorConfig.INTERACTION_MODES

export class InteractionController {
    constructor() {
        this.mode = InteractionMode.IDLE
        this.listeners = new Set()
    }

    getMode() {
        return this.mode
    }

    setMode(nextMode) {
        if (this.mode === nextMode) return

        const prev = this.mode
        this.mode = nextMode

        for (const l of this.listeners) {
            l(nextMode, prev)
        }
    }

    is(mode) {
        return this.mode === mode
    }

    subscribe(listener) {
        this.listeners.add(listener)
        return () => this.listeners.delete(listener)
    }

    reset() {
        this.setMode(InteractionMode.IDLE)
    }
}
